import { CaseAdmin } from "pwapi";

import AdminPanel from "components/admin/adminPanel/AdminPanel";
import HalfScreenPanel from "components/admin/editPanels/halfScreenEditPanel/HalfScreenPanel";

import QAReviewForm from "./qaReviewForm";

export type QAReviewsProps = {
  canReviewHold?: boolean;
  onClose: Function;
  onSubmit: Function;
  caseId: number;
  qaReviews?: CaseAdmin["qa_reviews"];
};

const QAReviewPanel = ({
  canReviewHold,
  onClose,
  onSubmit,
  caseId,
  qaReviews,
}: QAReviewsProps) => {
  return (
    <HalfScreenPanel onClose={() => onClose()}>
      <div className="HalfScreen__container">
        <AdminPanel
          title={{
            main: "Checked by QA Notes",
          }}
        >
          <QAReviewForm
            canReviewHold={canReviewHold}
            onClose={onClose}
            onSubmit={onSubmit}
            caseId={caseId}
            qaReviews={qaReviews}
          />
        </AdminPanel>
      </div>
    </HalfScreenPanel>
  );
};

export default QAReviewPanel;
